import { basierCirleRegular } from "@/styles/fonts";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";

export const CategoryTag = ({ variant, text, iconCategory = false, color }) => {
  const NetworkCategoryChip = styled((props) => (
    <Chip component="span" {...props} />
  ))(({ theme }) => ({
    //position: "absolute",
    //top: ".75rem",
    //left: ".75rem",
    //zIndex: "500",
    borderRadius: ".625rem",
    height: "1.25rem",
    backgroundColor: color,
    "& span": {
      color: theme.palette.common.white,
      fontWeight: `${basierCirleRegular.style.fontWeight} !important`,
      fontFamily: `${basierCirleRegular.style.fontFamily} !important`,
      textTransform: "uppercase",
      fontSize: ".875rem",
    },
    "&.MuiChip-root": {
      "&::before": {
        content: "''",
        display: iconCategory ? "" : "none",
        width: ".75rem",
        height: ".75rem",
        transform: "translateX(.5rem)",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        maskSize: ".75rem",
      },
    },
  }));

  return <NetworkCategoryChip variant={variant} label={text} />;
};
